<template>
	<div class="order-submission">
		<div style="padding:8px 0;background:#FFFBDE;text-align: center;color:red" v-if="is_exchange == 0">温馨提示：闪送订单已发货及处方订单开方后不予退款</div>
		<div class="allAddress" :style="store_self_mention ? '' : 'padding-top: 0.2rem'">
			<div class="nav acea-row" v-if="is_integral == 1 && is_yun != 1">
				<div class="item font-color-red" :class="shipping_type === 0 ? 'on' : 'on2'" @click="addressType(0)"
					v-if="store_self_mention"></div>
				<div class="item font-color-red" :class="shipping_type === 1 ? 'on' : 'on2'" @click="addressType(1)"
					v-if="store_self_mention"></div>
			</div>
			<div class="nav acea-row" v-else>
				<div class="item font-color-red pt" :class="shipping_type === 0 ? 'on' : 'on2'" @click="addressType(0)"
					v-if="store_self_mention"></div>
				<div class="item font-color-red pt" :class="shipping_type === 1 ? 'on' : 'on2'" @click="addressType(1)"
					v-if="store_self_mention && is_yun != 1"></div>
				<div class="item font-color-red pt pts" :class="shipping_type === 2 ? 'on' : 'on2'"
					@click="addressType(2)" v-if="store_self_mention && is_yun != 1"></div>
			</div>
			<div class="address acea-row row-between-wrapper" v-if="shipping_type === 0 || shipping_type === 2"
				@click="addressTap">
				<div class="addressCon" v-if="addressInfo.real_name">
					<div class="name">
						{{ addressInfo.real_name }}
						<span class="phone">{{ addressInfo.phone }}</span>
					</div>
					<div>
						<span class="default font-color-red" v-if="addressInfo.is_default">[默认]</span>
						{{ addressInfo.province }}{{ addressInfo.city
            }}{{ addressInfo.district }}{{ addressInfo.detail }}
					</div>
				</div>
				<div class="addressCon" v-else>
					<div class="setaddress">设置收货地址</div>
				</div>
				<div class="iconfont icon-jiantou"></div>
			</div>
			<div class="address acea-row row-between-wrapper" v-else>
				<div class="addressCon">
					<div class="name">
						{{ system_store.name }}
						<span class="phone">{{ system_store.phone }}</span>
					</div>
					<div>
						{{ system_store._detailed_address }}
					</div>
				</div>
			</div>
			<div class="line">
				<img src="@assets/images/line.jpg" />
			</div>
		</div>

		<!--    <div class="line">-->
		<!--      <img src="@assets/images/line.jpg" />-->
		<!--    </div>-->
		<!--    <div class="address acea-row row-between-wrapper" @click="addressTap">-->
		<!--      <div class="addressCon" v-if="addressInfo.real_name">-->
		<!--        <div class="name">-->
		<!--          {{ addressInfo.real_name }}-->
		<!--          <span class="phone">{{ addressInfo.phone }}</span>-->
		<!--        </div>-->
		<!--        <div>-->
		<!--          <span class="default font-color-red" v-if="addressInfo.is_default"-->
		<!--            >[默认]</span-->
		<!--          >-->
		<!--          {{ addressInfo.province }}{{ addressInfo.city-->
		<!--          }}{{ addressInfo.district }}{{ addressInfo.detail }}-->
		<!--        </div>-->
		<!--      </div>-->
		<!--      <div class="addressCon" v-else>-->
		<!--        <div class="setaddress">设置收货地址</div>-->
		<!--      </div>-->
		<!--      <div class="iconfont icon-jiantou"></div>-->
		<!--    </div>-->
		<OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo"></OrderGoods>
		<div class="wrapper">
			<div class="item acea-row row-between-wrapper" @click="couponTap"
				v-if="deduction === false && isusecoupon == 1">
				<div>优惠券</div>
				<div class="discount">
					{{ usableCoupon.coupon_title || "请选择" }}
					<span class="iconfont icon-jiantou"></span>
				</div>
			</div>
			<div class="item acea-row row-between-wrapper"
				v-if="deduction === false && is_exchange == 1 && is_yun != 1">
				<div>积分抵扣</div>
				<div class="discount">
					<div class="select-btn">
						<div class="checkbox-wrapper">
							<label class="well-check">
								<input type="checkbox" v-model="useIntegral" />
								<i class="icon"></i>
								<span class="integral">
									当前积分
									<span class="num font-color-red">
										{{ userInfo.integral || 0 }}
									</span>
								</span>
							</label>
						</div>
					</div>
				</div>
			</div>

			<div class="item acea-row row-between-wrapper" v-show="shipping_type === 0">
				<div>快递费用
					<span style="color:#999" v-if="system_store.parcel && system_store.parcel!=='0.00' && orderPrice.pay_postage > 0">
						（满{{system_store.parcel}}包邮）
					</span>
				</div>
				<div class="discount">
					{{ orderPrice.pay_postage > 0 ? orderPrice.pay_postage : "免运费" }}
				</div>
			</div>
			
			<div class="item acea-row row-between-wrapper" v-show="shipping_type === 2">
				<div>闪送费用</div>
				<div class="discount">
					{{ orderPrice.pay_deliver > 0 ? orderPrice.pay_deliver : "免运费" }}
				</div>
			</div>
			<div class="item acea-row row-between-wrapper" v-show="shipping_type === 2">
				<div style="color:red">（骑手闪送订单）满28元起送</div>
			</div>
			<div v-show="shipping_type === 1">
				<div class="item acea-row row-between-wrapper">
					<div>联系人</div>
					<div class="discount">
						<input type="text" placeholder="请填写您的联系姓名" v-model="contacts" />
					</div>
				</div>
				<div class="item acea-row row-between-wrapper">
					<div>联系电话</div>
					<div class="discount">
						<input type="text" placeholder="请填写您的联系电话" v-model="contactsTel" />
					</div>
				</div>
			</div>

			<div class="item">
				<div>备注信息</div>
				<textarea placeholder="请添加备注（150字以内）" v-model="mark"></textarea>
			</div>
		</div>
		<div class="wrapper">
			<div class="item">
				<div>支付方式</div>
				<div class="list">
					<div class="payItem acea-row row-middle" :class="active === 'weixin' ? 'on' : ''"
						@click="payItem('weixin')" v-show="isWeixin">
						<div class="name acea-row row-center-wrapper">
							<div class="iconfont icon-weixin2" :class="active === 'weixin' ? 'bounceIn' : ''"></div>
							微信支付
						</div>
						<div class="tip">微信快捷支付</div>
					</div>
					<div class="payItem acea-row row-middle" :class="active === 'weixin' ? 'on' : ''"
						@click="payItem('weixin')" v-show="!isWeixin">
						<div class="name acea-row row-center-wrapper">
							<div class="iconfont icon-weixin2" :class="active === 'weixin' ? 'bounceIn' : ''"></div>
							微信支付
						</div>
						<div class="tip">微信快捷支付</div>
					</div>
					<div class="payItem acea-row row-middle" :class="active === 'yue' ? 'on' : ''"
						@click="payItem('yue')" v-if="
              orderGroupInfo.cartInfo &&
                orderGroupInfo.cartInfo[0].productInfo.level_id <= 0 &&
                is_integral != 1 &&
                is_yun != 1 &&
                shipping_type != 2
            ">
						<div class="name acea-row row-center-wrapper">
							<div class="iconfont icon-icon-test" :class="active === 'yue' ? 'bounceIn' : ''"></div>
							余额支付
						</div>
						<div class="tip">可用余额：{{ userInfo.now_money || 0 }}</div>
					</div>
					<div class="payItem acea-row row-middle" :class="active === 'offline' ? 'on' : ''"
						@click="payItem('offline')" v-if="offlinePayStatus === 1 && deduction === false">
						<div class="name acea-row row-center-wrapper">
							<div class="iconfont icon-yinhangqia" :class="active === 'offline' ? 'bounceIn' : ''"></div>
							线下支付
						</div>
						<div class="tip">线下方便支付</div>
					</div>
				</div>
			</div>
		</div>
		<div class="moneyList">
			<div class="item acea-row row-between-wrapper" v-if="orderPrice.total_price !== undefined">
				<div>商品总价：</div>
				<div class="money">￥{{ orderPrice.total_price }}</div>
			</div>
			<div class="item acea-row row-between-wrapper" v-if="orderPrice.pay_postage > 0">
				<div v-show="shipping_type == 0">运费：</div>
				<div class="money" v-show="shipping_type == 0">
					￥{{ orderPrice.pay_postage }}
				</div>
				<div v-show="shipping_type == 2">闪送费用：</div>
				<div class="money" v-show="shipping_type == 2">
					￥{{ orderPrice.pay_deliver }}
				</div>
			</div>
			<div class="item acea-row row-between-wrapper" v-if="orderPrice.coupon_price > 0 && isusecoupon == 1">
				<div>优惠券抵扣：</div>
				<div class="money">-￥{{ orderPrice.coupon_price }}</div>
			</div>
			<div class="item acea-row row-between-wrapper" v-if="orderPrice.deduction_price > 0">
				<div>积分抵扣：</div>
				<div class="money">-￥{{ orderPrice.deduction_price }}</div>
			</div>
		</div>
		<div style="height:1.2rem"></div>
		<div class="footer acea-row row-between-wrapper">
			<div>
				合计:
				<span class="font-color-red">￥{{ orderPrice.pay_price }}</span>
			</div>
			<div class="settlement" @click="createOrder">立即结算</div>
		</div>
		<CouponListWindow v-on:couponchange="changecoupon($event)" v-model="showCoupon" :price="orderPrice.total_price"
			:checked="usableCoupon.id" @checked="changeCoupon"></CouponListWindow>
		<AddressWindow @checked="changeAddress" @redirect="addressRedirect" v-model="showAddress"
			:checked="addressInfo.id" ref="mychild"></AddressWindow>
	</div>
</template>
<style scoped>
	.pt {
		width: 33.3% !important;
	}

	.pt.on:before {
		border-width: 0 0rem 0.8rem 0 !important;
		border-radius: 0 !important;
	}

	.pt.on2:before {
		border-width: 0 0 0.6rem 0rem !important;
		border-radius: 0 !important;
	}

	.pt:before {
		width: 100% !important;
	}

	.pts:before {
		content: "骑手闪送" !important;
	}

	.btns .settlement {
		font-size: 0.3rem;
		color: #000;
		width: 2.4rem;
		height: 0.7rem;
		text-align: center;
		line-height: 0.7rem;
	}

	.order-submission .wrapper .shipping select {
		color: #999;
		padding-right: 0.15rem;
	}

	.order-submission .wrapper .shipping .iconfont {
		font-size: 0.3rem;
		color: #515151;
	}

	.order-submission .allAddress {
		width: 100%;
		background-image: linear-gradient(to bottom, #81c239 0%, #f5f5f5 100%);
		background-image: -webkit-linear-gradient(to bottom,
				#81c239 0%,
				#f5f5f5 100%);
		background-image: -moz-linear-gradient(to bottom, #81c239 0%, #f5f5f5 100%);
		padding-top: 1rem;
	}

	.order-submission .allAddress .nav {
		width: 7.1rem;
		margin: 0 auto;
	}

	.order-submission .allAddress .nav .item {
		width: 3.55rem;
	}

	.order-submission .allAddress .nav .item.on {
		position: relative;
		width: 2.5rem;
	}

	.order-submission .allAddress .nav .item.on:before {
		position: absolute;
		bottom: 0;
		content: "快递配送";
		font-size: 0.28rem;
		display: block;
		height: 0;
		width: 3.55rem;
		border-width: 0 0.2rem 0.8rem 0;
		border-style: none solid solid;
		border-color: transparent transparent #fff;
		z-index: 9;
		border-radius: 0.07rem 0.3rem 0 0;
		text-align: center;
		line-height: 0.8rem;
	}

	.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
		content: "到店自提";
		border-width: 0 0 0.8rem 0.2rem;
		border-radius: 0.3rem 0.07rem 0 0;
	}

	.order-submission .allAddress .nav .item.on2 {
		position: relative;
	}

	.order-submission .allAddress .nav .item.on2:before {
		position: absolute;
		bottom: 0;
		content: "到店自提";
		font-size: 0.28rem;
		display: block;
		height: 0;
		width: 4.6rem;
		border-width: 0 0 0.6rem 0.6rem;
		border-style: none solid solid;
		border-color: transparent transparent #cde2b6;
		border-radius: 0.4rem 0.06rem 0 0;
		text-align: center;
		line-height: 0.6rem;
	}

	.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
		content: "快递配送";
		border-width: 0 0.6rem 0.6rem 0;
		border-radius: 0.06rem 0.4rem 0 0;
	}

	.order-submission .allAddress .address {
		width: 7.1rem;
		height: 1.5rem;
		margin: 0 auto;
	}

	.order-submission .allAddress .line {
		width: 7.1rem;
		margin: 0 auto;
	}

	.order-submission .wrapper .item .discount input::placeholder {
		color: #ccc;
	}
</style>
<script>
	import OrderGoods from "@components/OrderGoods";
	import CouponListWindow from "@components/CouponListWindow";
	import AddressWindow from "@components/AddressWindow";
	import {
		postOrderConfirm,
		postOrderComputed,
		createOrder
	} from "@api/order";
	import {
		getZiXun
	} from "@api/store";
	import {
		mapGetters
	} from "vuex";
	import {
		pay
	} from "@libs/wechat";
	import {
		isWeixin
	} from "@utils";
	import axios from "axios";
	const NAME = "OrderSubmission",
		_isWeixin = isWeixin();
	export default {
		name: NAME,
		components: {
			OrderGoods,
			CouponListWindow,
			AddressWindow
		},
		props: {},
		data: function() {
			const {
				merchant_id = 0,
					is_integral = 0,
					is_exchange = 0,
					is_yun = 0
			} = this.$route.query;
			return {
				offlinePayStatus: 2,
				from: _isWeixin ? "weixin" : "weixinh5",
				deduction: true,
				isWeixin: _isWeixin,
				pinkId: 0,
				// active: _isWeixin ? "weixin" : "yue",
				active: "weixin",
				showCoupon: false,
				showAddress: false,
				addressInfo: {},
				couponId: 0,
				orderGroupInfo: "",
				usableCoupon: {},
				addressLoaded: false,
				useIntegral: false,
				orderPrice: {
					pay_price: "计算中"
				},
				mark: "",
				system_store: {
					// address: ["北京", "东城区"],
					// detailed_address: "东城区",
					// _detailed_address: "北京,东城区 东城区",
					// id: 1,
					// name: "测试门店",
					// phone: "18534575122"
				},
				shipping_type: 0,
				contacts: "",
				contactsTel: "",
				store_self_mention: 1,
				havecf: "",
				merchant_id: merchant_id,
				is_exchange: is_exchange,
				is_integral: is_integral,
				is_yun: is_yun,
				userInfo: {},
				orderid: "",
				// showMask: false,
				shipping_type2: 0,
				isusecoupon: ""
			};
		},
		computed: mapGetters(["userInfo"]),
		watch: {
			useIntegral() {
				this.computedPrice();
			},
			$route(n) {
				this.is_exchange = n.query.is_exchange;
				this.merchant_id = n.query.merchant_id;
				this.is_integral = n.query.is_integral;
				this.is_yun = n.query.is_yun;
				if (n.name === NAME) this.getCartInfo();
			},
			shipping_type() {
				this.computedPrice();
			}
		},
		mounted: function() {
			var that = this;
			this.getCartInfo();
			this.getcoupons();
			if (that.$route.query.pinkid !== undefined)
				that.pinkId = that.$route.query.pinkid;
		},
		methods: {
			addressType: function(index) {
				var start_time=this.system_store.start_time
				if(this.system_store.end_time){
					var end_time=this.system_store.end_time.substr((" ") + 1)
				}
				var time=this.getDate()
				if(start_time || end_time){
					if(time<start_time){
						return this.$dialog.error("骑手闪送时间"+start_time+"-"+end_time);
					}
					if(time>end_time){
						return this.$dialog.error("骑手闪送时间"+start_time+"-"+end_time);
					}
				}
				if (index && !this.system_store.id)
					return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
				this.shipping_type = index;
			},
			getDate(type) {
				const date = new Date();
				let H =date.getHours(); //获取当前小时数(0-23)
				if(H<10){
					H="0"+H
				}
				let I =date.getMinutes(); //获取当前分钟数(0-59)
				if(I<10){
					I="0"+I
				}
				return `${H}:${I}`;
			},
			getcoupons() {
				getZiXun().then(res => {
					this.isusecoupon = res.data.is_use_coupon;
				});
			},
			computedPrice() {
				if (this.shipping_type == 2) {
					this.shipping_type2 = 4;
				} else {
					this.shipping_type2 = this.shipping_type + 1;
					console.log(this.shipping_type2);
				}
				postOrderComputed(this.orderGroupInfo.orderKey, {
					payType: this.active,
					addressId: this.addressInfo.id,
					useIntegral: this.useIntegral ? 1 : 0,
					couponId: this.usableCoupon.id || 0,
					shipping_type: parseInt(this.shipping_type2)
					// shipping_type: 4
				}).then(res => {
					const data = res.data;
					if (data.status === "EXTEND_ORDER") {
						if (data.result.code == "112") {
							if (this.shipping_type2 == 4) {
								this.$dialog.error(res.data.result.message);
								this.shipping_type = 0;
							} else {
								this.$router.replace({
									path: "/order/detail/" + data.result.orderId
								});
							}
						} else {
							this.$dialog.error(res.data.result.message);
						}
					} else {
						this.orderPrice = data.result;
					}
				});
			},
			getCartInfo() {
				const cartIds = this.$route.params.id;
				if (!cartIds) {
					this.$dialog.error("参数有误");
					return this.$router.go(-1);
				}
				postOrderConfirm({
						cartId: cartIds,
						merchant_id: this.merchant_id,
						is_integral: this.is_integral
					})
					.then(res => {
						// (this.showMask = "false"),
						this.havecf = res.data.havecf;
						this.offlinePayStatus = res.data.offline_pay_status;
						this.orderGroupInfo = res.data;
						this.deduction = res.data.deduction;
						this.usableCoupon = res.data.usableCoupon || {};
						this.addressInfo = res.data.addressInfo || {};
						this.system_store = res.data.system_store || {};
						this.userInfo = res.data.userInfo || {};
						this.computedPrice();
					})
					.catch(() => {
						// this.$dialog.error("加载订单数据失败");
						this.$router.go(-1)
					});
			},
			addressTap: function() {
				this.showAddress = true;
				if (!this.addressLoaded) {
					this.addressLoaded = true;
					this.$refs.mychild.getAddressList();
				}
			},
			addressRedirect() {
				this.addressLoaded = false;
				this.showAddress = false;
			},
			couponTap: function() {
				this.showCoupon = true;
			},
			changeCoupon: function(coupon) {
				if (!coupon) {
					this.usableCoupon = {
						coupon_title: "不使用优惠券",
						id: 0
					};
				} else {
					this.usableCoupon = coupon;
				}
				this.computedPrice();
			},
			payItem: function(index) {
				this.active = index;
			},
			changeAddress(addressInfo) {
				this.addressInfo = addressInfo;
			},
			// closeBtn() {
			// 	this.showMask = "false";
			// 	this.$router.replace({
			// 		path: "/order/detail/" + this.orderid
			// 	});
			// },
			// confirmBtn() {
			// 	this.showMask = "false";
			// 	this.$router.push({
			// 		path: "/recipel?orderid=" + this.orderid
			// 	});
			// },
			createOrder() {
				var that = this;
				let shipping_type = this.shipping_type;
				if (!this.active) {
					return this.$dialog.toast({
						mes: "请选择支付方式"
					});
				}
				if (!this.addressInfo.id && !this.shipping_type) {
					return this.$dialog.toast({
						mes: "请选择收货地址"
					});
				}
				if (this.shipping_type == 1) {
					if (
						(this.contacts === "" || this.contactsTel === "") &&
						this.shipping_type
					)
						return this.$dialog.toast({
							mes: "请填写联系人或联系人电话"
						});
					if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
						return this.$dialog.toast({
							mes: "请填写正确的手机号"
						});
					}
					if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
						return this.$dialog.toast({
							mes: "请填写您的真实姓名"
						});
					}
				}
				this.$dialog.loading.open("生成订单中");
				var is_judge = 0;
				if (this.havecf == "1") {
					is_judge = 1;
				}
				if (this.shipping_type == 2) {
					this.shipping_type2 = 4;
				} else {
					this.shipping_type2 = this.shipping_type + 1;
				}
				createOrder(this.orderGroupInfo.orderKey, {
						real_name: this.contacts,
						phone: this.contactsTel,
						addressId: this.addressInfo.id,
						useIntegral: this.useIntegral ? 1 : 0,
						couponId: this.usableCoupon.id || 0,
						payType: this.active,
						pinkId: this.pinkId,
						seckill_id: this.orderGroupInfo.seckill_id,
						combinationId: this.orderGroupInfo.combination_id,
						bargainId: this.orderGroupInfo.bargain_id,
						from: "",
						is_judge: is_judge,
						// from:this.from,
						mark: this.mark || "",
						shipping_type: this.shipping_type2
					})
					.then(res => {
						this.$dialog.loading.close();
						const data = res.data;
						switch (data.status) {
							case "ORDER_EXIST":
							case "EXTEND_ORDER":
							case "PAY_DEFICIENCY":
							case "PAY_ERROR":
								this.$dialog.toast({
									mes: res.msg
								});
								this.$router.replace({
									path: "/order/detail/" + data.result.orderId
								});
								break;
							case "SUCCESS":
								this.$dialog.success(res.msg);
								// if (this.havecf == "1") {
								// 	this.orderid = data.result.orderId;
								// 	// this.showMask = "true";
								// 	return false;
								// }
								this.$router.replace({
									path: "/order/detail/" + data.result.orderId
								});
								break;
							case "WECHAT_H5_PAY":
								this.$router.replace({
									path: "/order/detail/" + data.result.orderId
								});
								setTimeout(() => {
									location.href = data.result.jsConfig.mweb_url;
								}, 100);
								break;
							case "WECHAT_PAY":
								// 云药库支付
								if (data.result.cloud_mid !== 0 && is_judge !== 1) {
									window.location.href =
										"http://xlx.funengtuan.com/api/integral_auth?orders_sn=" +
										data.result.orderId +
										"&back_url=" +
										window.location.host +
										"&pay_type=integral";
									return;
								}
								if (
									this.orderGroupInfo.cartInfo[0].is_integral === 1 &&
									this.active == "weixin" &&
									data.result.orderId != ""
								) {
									// window.location.href = "http://sifei.funengtuan.com/api/integral_auth?orders_sn=" + data.result.orderId +"&back_url=" + window.location.host + '&pay_type=integral';
									window.location.href =
										"http://qqhy.funengtuan.com/api/integral_auth?orders_sn=" +
										data.result.orderId +
										"&back_url=" +
										window.location.host +
										"&pay_type=integral";
									return;
								}
								//处方商品走特殊通道
								if (is_judge || that.shipping_type2 == 4) {
									window.location.href =
										"http://sifei.funengtuan.com/api/integral_auth?orders_sn=" +
										data.result.orderId +
										"&back_url=" +
										window.location.host +
										"&pay_type=vip";
									// window.location.href = "http://wx.dxkyyy.com/api/integral_auth?orders_sn=" + data.result.orderId +
									// 	"&back_url=" + window.location.host + '&pay_type=vip';
									return;
								}
								//会员商品走特殊通道
								// if (this.orderGroupInfo.cartInfo[0].productInfo.level_id > 0) {
								//   window.location.href =
								//     "http://sifei.funengtuan.com/api/integral_auth?orders_sn=" +
								//     data.result.orderId +
								//     "&back_url=" +
								//     window.location.host +
								//     "&pay_type=vip";
								//   // window.location.href = "http://wx.dxkyyy.com/api/integral_auth?orders_sn=" + data.result.orderId +
								//   // 	"&back_url=" + window.location.host + '&pay_type=vip';
								//   return;
								// }
								pay(data.result.jsConfig).finally(() => {
									this.$router.replace({
										path: "/order/detail/" + data.result.orderId
									});
								});
						}
					})
					.catch(err => {
						console.log(err);
						this.$dialog.loading.close();
						this.$dialog.error(err.msg || "创建订单失败");
					});
			}
		}
	};
</script>
